export function safeCallbackUrl(url: string | null | undefined) {
  if (!url || !url.startsWith('/') || url.startsWith('//') || url.includes('\\')) {
    return '/';
  }

  return url;
}
